'use client';

import { ArticleCarousel } from '@/components/article/article-carousel';
import { relatedArticleToCarouselItem } from '@/components/article/article-carousel-item';
import type { RelatedArticleRef } from '@/lib/articles';

export function RelatedArticles({ items }: { items: RelatedArticleRef[] }) {
  if (!items.length) return null;

  return (
    <section aria-labelledby="related-articles-heading" className="mt-16 pt-12">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <h2
          id="related-articles-heading"
          className="font-medium leading-tight tracking-tight text-ink text-subheader-lg sm:text-header-sm"
        >
          Related articles
        </h2>
      </div>

      <ArticleCarousel
        items={items.map(relatedArticleToCarouselItem)}
        previousLabel="Previous related articles"
        nextLabel="Next related articles"
        className="mt-8"
        controlsClassName="mb-6 flex justify-end gap-2"
        showDots
        dotLabelPrefix="Go to related articles position"
      />
    </section>
  );
}
